export default {
      id: "ic_warning_yellow-usage",
      viewBox: "0 0 68 60",
      url: "/" + "images/icons.3.109.2.svg#ic_warning_yellow-usage",
      toString: function () {
        return this.url;
      }
    }